export default "__VITE_ASSET__flNZjsW___"